import { useTranslation } from "react-i18next";

export default function FieldsCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.fields");
}
